var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIconVisible)?_c('div',[_c('a-icon',{attrs:{"icon":_vm.currentIcon,"width":_vm.width,"height":_vm.height,"no-hover":"","original":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }